import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {DialogFooter} from '@/components/ui/dialog'

export function DialogSubmitFooter({
  onCancel,
  onSubmit,
  submitLabel,
  pending,
  destructive,
  testId,
}: {
  onCancel: () => void
  onSubmit: () => void
  submitLabel: string
  pending: boolean
  destructive?: boolean
  testId?: string
}) {
  const {t} = useTranslation()
  return (
    <DialogFooter>
      <Button type="button" variant="outline" onClick={onCancel}>
        {t('common.cancel')}
      </Button>
      <Button
        type="button"
        variant={destructive ? 'destructive' : 'default'}
        data-testid={testId}
        disabled={pending}
        onClick={onSubmit}>
        {pending ? t('common.saving') : submitLabel}
      </Button>
    </DialogFooter>
  )
}
